import { useEffect } from 'react'
import { isValidToken } from '../services/auth-utils'
import useUser from './use-user'
import { redirect } from 'react-router-dom'
import { MenuLinks } from '../../constants'

export function useCheckUserToken() {
  const { user } = useUser()

  useEffect(() => {
    if (!isValidToken(user?.token)) redirect(MenuLinks.DASHBOARD)
  }, [user?.token])
}
